export default __webpack_public_path__ + "static/media/mindfullness.aee02463.svg";